export enum DataFormat {
	MOODLE_XML = "Moodle XML",
	EVO_JSON = "Evo JSON",
}
